(function () {
    'use strict';

    angular.module("imApp").factory("paymentLangService", ['$ihttp', function ($ihttp) {
        var service = {
            getPaymentLang: function (parms) {
                return $ihttp.post({
                    method: method_no,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();